import React, { useEffect, useState } from 'react';
import { readNotes, uploadArchive, uploadNote } from '../../controllers/classnotes.controller';
import NotesListContainer from "../containers/notesListContainer"
import {toast} from "react-hot-toast";

function ClassNotes({userData}) {

  const [noteFields, setNoteFields] = useState({user:userData,archiveName:"", archiveURL:"", year:""})
  const [note, setNote]=useState("false")
  const [notesList, setNotesList]=useState("")


    //!CREATE URL
  function setArchiveUrl(event) {
    event.preventDefault()

    let path=`${noteFields.user}-${noteFields.archiveName}`
    if(note !== "false"){
      uploadArchive(note,path).then(
        url => setNoteFields({...noteFields,archiveURL:url})
      ).catch(
        error => toast.error(error)
      )
    }else{
      toast("vacio")
    }
  }

  //!SET URL And create doc in database
  function test(event) {
    event.preventDefault()
    uploadNote (
      noteFields.user,
      noteFields.archiveName,
      noteFields.archiveURL, 
      noteFields.year
    )
  }

  //!READ NOTES
  useEffect(() => {
    readNotes().then(
      data => setNotesList(data)
    ).catch(
      error => toast.error(error)
    )
  }, [])
  

  return (
    <div className="d-flex flex-column">

        <div className="p-3 greenhouseBg">
              <h1 className="text-white tittle mt-5">APUNTES</h1>
              <p className="text-white mb-5">Encuentra aquí los apuntes compartidos por otros estudiantes y comparte los tuyos en formato PDF.</p>
        </div>

      <div className="d-flex flex-column bg-white p-3 gap-3">

          <div className="rounded creamBackground p-3">

            <h1 className="tittle dark mainText pb-4">SUBIR APUNTE</h1>
            <p>Solamente subir en formato PDF o Word(doc).</p>
            <p>Nombrar los archivos correctamente, esto ayudará a facilitar la búsqueda y organización.</p>
            <p>Subir solo archivos de interés para el resto de estudiantes, aquellos fuera de la temática serán eliminados.</p>
            
            <form className="mt-4 d-flex flex-column align-items-center" action="">
              <div className="col-12">
                <label className="fw-bold" htmlFor="apunteInput">Nombre del Documento</label>
                <input value={noteFields.archiveName} onChange={e => setNoteFields({...noteFields,archiveName:e.target.value})} className='form-control form-control-lg' type="text" id='apunteInput' placeholder='materia-descripción-carrera-año'/>
                <p>Ejemplo: químicaGeneral-apuntesTeoricos-LECA-2018 </p>
              </div>

              <div className="col-12">
                <label className="fw-bold" htmlFor="yearInput">Año del documento</label>
                <input value={noteFields.year} onChange={e => setNoteFields({...noteFields,year:e.target.value})} className='form-control form-control-lg' type="text" id='yearInput' placeholder='01/01/2018'/>
                <p>Ejemplo:2018 </p>
              </div>

              <div className="pb-3">
                <label className="fw-bold" htmlFor="apunteInput">Archivo</label>

                <input onChange={e => setNote(e.target.files[0])}  type="file" className='form-control form-control-lg my-2'/>
                <button onClick={setArchiveUrl} className='btn btn-lg btn-success regularText col-12 mb-1'>Guardar Archivo</button>
                <p>Selecciona el archivo y luego toca el boton guardar archivo.</p>
 
              </div>

              <p className="fw-bold">Finalmente haz click en subir archivo</p>
              <button onClick={test} className='brownBtn'>Subir archivo</button>
            </form>

          </div>

          <div className="rounded creamBackground p-3 pb-4">
            <h1 className="tittle dark mainText pb-4">APUNTES DISPONIBLES</h1>
            <p>Haz click sobre ellos para descargar</p>
            
            <NotesListContainer NotesList={notesList}/>

          </div>

      </div>

    </div>
  )
}

export default ClassNotes